import React from "react"
import {serverSideTranslations} from "next-i18next/serverSideTranslations"
import NavBar from "../components/navigation/NavBar"
import Footer from "../components/footer/Footer"
import nextI18NextConfig from "../next-i18next.config.js"
import {useTranslation} from "next-i18next"
import MbpHead from "../components/head/MbpHead"
import {getPageData} from "../pageData"
import ComparisonPageContent from "../components/comparisonComponents/ComparisonPageContent"
import BikeSuggest from "../components/reusable/BikeSuggest"

const ComparisonPage = () => {
	const {t} = useTranslation()
	const title = t("Comparison Page")
	const description = t("")

	return (
		<>
			<MbpHead>
				<title>
					{title}
				</title>
				<meta name="description"
					content={description}/>
				<meta property="og:title"
					content={title}/>
				<meta property="og:description"
					content={description}/>
			</MbpHead>
			<NavBar/>
			<main className="mt-5">
				<ComparisonPageContent/>
			</main>
			<BikeSuggest t={t}/>
			<Footer/>
		</>
	)
}

export async function getStaticProps({locale}) {
	return {
		props: {
			...(await getPageData(locale)),
			...(await serverSideTranslations(locale, ["common", "URL", "search", "filters"], nextI18NextConfig))
		}
	}
}

export default ComparisonPage
